import { useEffect } from "react";
import Lenis from "lenis";
import { Navbar } from "@/components/landing/Navbar";
import { Hero } from "@/components/landing/Hero";
import { Marquee } from "@/components/landing/Marquee";
import { TrustBar } from "@/components/landing/TrustBar";
import { Toolkit } from "@/components/landing/Toolkit";
import { ValueCompare } from "@/components/landing/ValueCompare";
import { Audiences } from "@/components/landing/Audiences";
import { Experts } from "@/components/landing/Experts";
import { Testimonials } from "@/components/landing/Testimonials";
import { Founder } from "@/components/landing/Founder";
import { FAQ } from "@/components/landing/FAQ";
import { FinalCTA } from "@/components/landing/FinalCTA";
import { Footer } from "@/components/landing/Footer";
import { StickyBar } from "@/components/landing/StickyBar";

function App() {
  useEffect(() => {
    const lenis = new Lenis({ duration: 1.15, anchors: true, smoothWheel: true });
    let raf;
    const loop = (time) => {
      lenis.raf(time);
      raf = requestAnimationFrame(loop);
    };
    raf = requestAnimationFrame(loop);
    return () => {
      cancelAnimationFrame(raf);
      lenis.destroy();
    };
  }, []);

  return (
    <div className="min-h-screen bg-cream font-body text-navy">
      <div className="noise-overlay" aria-hidden="true" />
      <Navbar />
      <main>
        <Hero />
        <Marquee />
        <TrustBar />
        <Toolkit />
        <ValueCompare />
        <Audiences />
        <Experts />
        <Testimonials />
        <Founder />
        <FAQ />
        <FinalCTA />
      </main>
      <Footer />
      <StickyBar />
    </div>
  );
}

export default App;
